import { defineStore } from "pinia";

// Parallels useCollectionCategoryStore: a separate store from the smart-feed
// store so the chip-list fetch's apiGet doesn't toggle the smart-feed store's
// shared isLoading flag (which would race the feed's initial fetch).
export const usePublicationHashtagStore = defineStore("publication-hashtag-store", {
  state: () => ({
    publicationHashtags: [],
    isLoadingPublicationHashtags: false,
  }),
  actions: {
    fetchPublicationHashtagsForPublication(publicationId) {
      if (!publicationId) {
        this.publicationHashtags = [];
        return;
      }
      this.isLoadingPublicationHashtags = true;
      this.apiGet(
        `/publication/${publicationId}/hashtags`,
        {},
        data => {
          this.publicationHashtags = data.hashtags;
          this.isLoadingPublicationHashtags = false;
        },
        () => {
          this.publicationHashtags = [];
          this.isLoadingPublicationHashtags = false;
        },
      );
    },
  },
});
